/**
 * QuickBooksIntegration — admin page at /admin/quickbooks.
 *
 * Two tabs: the OAuth connection to a QBO company, and the inbound sync that
 * turns QuickBooks estimates, invoices, POs and payments into orders on the
 * Sourcing Desk.
 */
import { useState } from "react";
import { Plug, ArrowLeftRight } from "lucide-react";
import { useAuth } from "@/App";
import QboConnectionCenter from "./QboConnectionCenter";
import QboSyncCenter from "./QboSyncCenter";

const TABS = [
  { key: "connection", label: "Connection", icon: Plug },
  { key: "sync", label: "Inbound sync", icon: ArrowLeftRight },
];

export default function QuickBooksIntegration() {
  const { token } = useAuth();
  const [tab, setTab] = useState("connection");

  return (
    <div className="p-6 max-w-6xl mx-auto" data-testid="quickbooks-integration-page">
      <div className="flex gap-2 mb-5">
        {TABS.map(({ key, label, icon: Icon }) => (
          <button key={key} type="button" onClick={() => setTab(key)}
            className={`px-3.5 py-2 rounded-lg text-xs font-bold uppercase tracking-wider inline-flex items-center gap-1.5 transition-colors ${
              tab === key ? "bg-slate-900 text-white" : "bg-slate-100 text-slate-600 hover:bg-slate-200"}`}
            data-testid={`qbo-page-tab-${key}`}>
            <Icon className="w-3.5 h-3.5" /> {label}
          </button>
        ))}
      </div>
      {tab === "connection" ? <QboConnectionCenter token={token} /> : <QboSyncCenter token={token} />}
    </div>
  );
}
